module.exports = __webpack_public_path__ + "static/audio-notetaker-jumbotron-2d0fe443b6a8436e0aa857728d826fd3.png";